import { PaymentsToApproveList } from "../components/PaymentsToApproveList/PaymentsToApproveList";
import { TransactionsList } from "../components/List/TransactionsList";
import { TransactionsCreate } from "../components/Create/TransactionsCreate";
import { TransactionsEdit } from "../components/Edit/TransactionsEdit";
import { TransactionsView } from "../components/View/TransactionsView";
import { ContainerOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
import { ReadyForPaymentList } from "../components/ReadyForPaymentList/ReadyForPaymentList";
export const TRANSACTIONS_LIST = {
    path: "/admin/transactions",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: TransactionsList,
    menu: {
        key: "TRANSACTIONS_LIST",
        label: "management.transactions.menu.title",
        icon: ContainerOutlined,
    },
};
export const PAYMENTS_TO_APPROVE_LIST = {
    path: "/admin/transactions/payments-to-approve",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: PaymentsToApproveList,
    menu: {
        key: "PAYMENTS_TO_APPROVE_LIST",
        label: "management.transactions.menu.payments_to_approve",
        icon: ContainerOutlined,
    },
};
export const READY_FOR_PAYMENT_LIST = {
    path: "/admin/transactions/ready-for-payment",
    roles: [UserRole.ADMIN, UserRole.SHAREHOLDER],
    component: ReadyForPaymentList,
    menu: {
        key: "READY_FOR_PAYMENT_LIST",
        label: "management.transactions.menu.ready_for_payment",
        icon: ContainerOutlined,
    },
};
export const TRANSACTIONS_CREATE = {
    path: "/admin/transactions/create",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: TransactionsCreate,
};
export const TRANSACTIONS_EDIT = {
    path: "/admin/transactions/:id/edit",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: TransactionsEdit,
};
export const TRANSACTIONS_VIEW = {
    path: "/admin/transactions/:id/view",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: TransactionsView,
};
